import { useWatch } from "react-hook-form";

import { useArtwork, useArtworkForm } from "@design-lab/entities/artwork";
import { useProductColors } from "@design-lab/entities/product";
import { useIsSample } from "@design-lab/shared/lib/config";
import { ChangeShirt } from "./ChangeShirt";
import { ChangeShirtColor } from "./ChangeShirtColor";
import { RemoveBackground } from "./RemoveBackground";

export function ToolBar() {
  const { form } = useArtworkForm();
  const { getArtwork } = useArtwork();
  const { colors, recommendedColors } = useProductColors();
  const isSample = useIsSample();
  const artworkForm = useWatch({
    control: form.control
  });
  const side = artworkForm?.currentPlacement === "back" ? "back" : "front";
  const artworkIdForm =
    side === "back" ? artworkForm?.back?.artworkId : artworkForm?.front?.artworkId;
  const artworkInfo = artworkForm?.info?.[side];
  const artwork = artworkIdForm ? getArtwork(artworkIdForm) : null;

  const showRemoveBackground =
    artwork?.canRemoveBg && artworkInfo?.enhancementTier === "full_enhancements";

  const showChangeShirtColor = (colors?.length > 1 || recommendedColors?.length > 1) && !isSample;

  return (
    <div className="rounded-[10px] bg-gray-200 p-1">
      <div className="flex flex-wrap items-center justify-center gap-2 2xl:flex-nowrap">
        {showRemoveBackground && <RemoveBackground />}
        {showChangeShirtColor && <ChangeShirtColor className="w-full 2xl:w-auto" />}
        {!isSample && <ChangeShirt />}
      </div>
    </div>
  );
}
